<div class="snap-card" [ngClass]="snapType === ('analysis'||'details') ? 'analysis' : 'home'">
    <div class="container img-container">
            <button mat-mini-fab color="primary" [disabled]="(currentIntervalIndex$ | async) == 0" (click)="goPrevious()" class="arrow left">
                <mat-icon svgIcon="arrow-left-white"></mat-icon>
            </button>
            <div [ngClass]="snapType === ('analysis' || 'details') ? 'image-analysis' : 'image-home'" class="snapshot-img-container">
                <div class="full-width image-wrapper">
                    <div class="full-width">
                    <div *ngIf="imageLoading" class="container full-height centered-content loader">
                        <mat-spinner strokeWidth="3" [diameter]="50"></mat-spinner>
                    </div>
                        <img
                          *ngIf="!imageLoading"
                          [ngClass]="{
                            'red-border': (currentInterval$ | async)?.thresholdCount,
                            'yellow-border': (currentInterval$ | async)?.slabs
                          }"
                          (load)="onImageLoad()"
                          (error)="onImageLoadError()"
                          (click)="showFullImg()"
                          [src]="isTiff ? (showMergedImage ? mergedImageUrl : baseImageUrl) : imgsrc"
                          alt="Slide image"
                        />
                      </div>
                        <div class="count-container" *ngIf="(currentInterval$ | async)?.slabs || (currentInterval$ | async)?.thresholdCount">
                            <div class="count-box">
                                <mat-icon svgIcon="warn-yellow"></mat-icon>&nbsp;
                                <span>Slabs: {{(currentInterval$ | async).slabs}}</span>&nbsp;&nbsp;
                                <mat-icon svgIcon="warn-red"></mat-icon>&nbsp;
                                <span>Thresholds: {{(currentInterval$ | async).thresholdCount}}</span>
                            </div>
                        </div>
                </div>
                <div class="hover-buttons-wrapper">
                    <div class="button-group">
                        <div class="static-buttons">
                            <button mat-icon-button class="hover-button" 
                                (click)="handleAction('showMuckpile')" matTooltip="Muckpile Details" [ngClass]="{'disable': !muckpileId}">
                                <mat-icon class="hover-button-icon" svgIcon="muckpile" ></mat-icon>
                            </button>

                            <button 
                                mat-icon-button class="hover-button" 
                                [matTooltip]='(taggedVehicle$ | async)?.name' [ngClass]="{'disable': !(taggedVehicle$ | async)?.name}"> 
                                <mat-icon class="hover-button-icon" svgIcon="vehicle"></mat-icon>
                            </button>
                        </div>
                        <div class="hover-buttons-container">
                            <ng-container *ngFor="let button of hoverButtons">
                                <button *ngIf="!(snapType === 'details' && button.icon === 'psd-white')" mat-icon-button 
                                    class="hover-button" (click)="handleAction(button.action)"
                                    matTooltip="{{ button.tooltip }}" [ngClass]="{'disable': button.disable}">
                                    <mat-icon class="hover-button-icon" svgIcon="{{ button.icon }}"></mat-icon>
                                </button>
                            </ng-container>
                            <button mat-icon-button *ngIf="isTiff" class="hover-button" (click)="toggleTiffView()"
                                [matTooltip]="showMergedImage ? 'Hide contours' : 'Show contours'">
                                <mat-icon class="hover-button-icon" svgIcon="camera"></mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <button mat-mini-fab color="primary" [disabled]="(currentIntervalIndex$ | async) == ((intervals$| async)?.length -1)" (click)="goNext()" class="arrow right">
                <mat-icon svgIcon="arrow-right-white"></mat-icon>
            </button>
        <ng-template #fullimgtemplate>
            <div class="time-content">
                <div *ngIf="!imageLoading" class="time-content-wrapper" cdkDrag cdkDragBoundary="body">
                    <div class="centered-content">
                        <div class="belt-item container">
                            <div class="card-label">Begin
                                <span>
                                    <mat-icon [inline]="true" class="font-large">access_time</mat-icon>
                                </span>
                            </div>
                            <div class="card-value belt-up">{{(currentInterval$ | async).begin | date :dateTimeFormat}}</div>
                        </div>
                        <div class="belt-item container">
                            <div class="card-label">End
                                <span>
                                    <mat-icon [inline]="true" class="font-large">access_time</mat-icon>
                                </span>
                            </div>
                            <div class="card-value belt-up">{{(currentInterval$ | async).end | date :dateTimeFormat}}</div>
                        </div>
                    </div>
                </div>
                <button mat-mini-fab color="primary" [disabled]="(currentIntervalIndex$ | async) == 0" (click)="goPrevious()"
                    class="arrow left image-swap-left-button">
                    <mat-icon svgIcon="arrow-left-white"></mat-icon>
                </button>
                <button mat-icon-button class="close-btn" (click)="closeFullImg()">
                    <mat-icon class="close-icon">close</mat-icon>
                </button>
                <div *ngIf="imageLoading" class="container full-height centered-content loader">
                    <mat-spinner strokeWidth="3" [diameter]="50"></mat-spinner>
                </div>
                <img 
                  *ngIf="!imageLoading"
                  [src]="isTiff ? (showMergedImage ? mergedImageUrl : baseImageUrl) : imgsrc"
                  class="full-height full-width"
                  (load)="onImageLoad()"
                  (error)="onImageLoadError()"
                  alt="Slide image"
                />
                <button mat-mini-fab color="primary" [disabled]="(currentIntervalIndex$ | async) == ((intervals$| async)?.length -1)"
                    (click)="goNext()" class="arrow right image-swap-right-button">
                    <mat-icon svgIcon="arrow-right-white"></mat-icon>
                </button>
            </div>
        </ng-template>
    </div>
</div>